import Vue from 'vue';

// Domain
import { InvestmentTypeHiringStepStateManager } from '../../domain/state/investment-type-hiring-step-state-manager';
import InvestmentTypeHiringStepState from '../../domain/state/investment-type-hiring-step-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class InvestmentTypeHiringStepVueStateManager
implements InvestmentTypeHiringStepStateManager {
  private _state: InvestmentTypeHiringStepState = Vue.observable<InvestmentTypeHiringStepState>(
    new InvestmentTypeHiringStepState(),
  );

  private readonly observers: Observer[] = [];

  get state(): InvestmentTypeHiringStepState {
    return this._state;
  }

  set state(value: InvestmentTypeHiringStepState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<InvestmentTypeHiringStepState>) {
    type Keys = keyof InvestmentTypeHiringStepState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
